import { DisclosureMini, Disclosure } from '@arc-ui/components';
import { ListDisclosureProps } from '../../../types/ee-header';

const ListDisclosure = ({
  summary,
  isMobile,
  children,
  isTablet,
}: ListDisclosureProps) =>
  isMobile || isTablet ? (
    <DisclosureMini
      summary={summary}
      iconPosition="right"
      size="l"
      id="footer-disclosure-items"
    >
      {children}
    </DisclosureMini>
  ) : (
    <Disclosure summary={summary}>{children}</Disclosure>
  );

export default ListDisclosure;
